import { OnsiteEditDto, VariationDto } from "@intelligems/ig-types";

export const getOnsiteEditsFromExperienceDto = (variations: VariationDto[]) => {
  const tempEdits: OnsiteEditDto[] = [];
  for (const variation of variations) {
    for (const edit of variation.onsiteEdits ?? []) {
      tempEdits.push(edit);
    }
  }
  return tempEdits;
};
